import React from 'react';

type Props = {
  className?: string;
  width?: string;
  height?: string;
};

const ClockBlack: React.FC<Props> = ({ className, width = '16', height = '16' }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.99967 14.6673C11.6816 14.6673 14.6663 11.6825 14.6663 8.00065C14.6663 4.31875 11.6816 1.33398 7.99967 1.33398C4.31778 1.33398 1.33301 4.31875 1.33301 8.00065C1.33301 11.6825 4.31778 14.6673 7.99967 14.6673Z" fill="#0B1215" />
    <path d="M8 4V8L10.6667 9.33333" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ClockBlack;
